<div class="flex flex-row items-center py-[70px] px-[30px] max-w-[1200px] mx-auto">
  <div class="col">
    <div class="mb-[36px]">
      <div class="mb-[16px] text-[32px] text-c-d1">
        {{ 'channel-account_list_empty_html_title' | translate }}
        <!-- Connect your first account. -->
      </div>
      <div class="text-l text-c-l2">
        {{ 'channel-account_list_empty_html_desc' | translate }}
        <!-- To start experiencing the product quickly, we recommend you start by connecting an Airbnb account. -->
      </div>
    </div>

    <div class="channel-list grid gap-[15px]" [class.intl]="isInternational">
      <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 5 }" *ngIf="loading; else initialized"></nz-skeleton>

      <ng-template #initialized>
        <ng-container *ngFor="let channel of listOfChannel; first as isFirst">
          <div
            [class.first]="isFirst"
            class="channel-card relative flex flex-row items-center justify-between w-[250px] h-[60px] px-[12px] border border-solid border-c-gs rounded-[10px]"
          >
            <img
              class="h-[28px]"
              [ngClass]="{
                '!h-[34px]': isInternational && isFirst
              }"
              [src]="channel.logo"
            />
            <div
              [style.backgroundColor]="channel.bg_color"
              class="connect py-[2px] px-[10px] text-[12px] rounded-[4px] leading-[26px] text-white cursor-pointer"
              (click)="onSelectChannel.emit(channel.thirdparty_type)"
            >
              {{ 'channel-account-channel_menu_html-关联' | translate }}
            </div>
            <div
              *ngIf="isInternational && isFirst"
              class="absolute top-0 right-0 px-[8px] h-[14px] leading-[14px] rounded-bl-[14px] rounded-tr-[14px] bg-[#21d3d1] text-white text-[9px]"
            >
              {{ 'channel-account_list_empty_html_easiest' | translate }}
              <!-- Easiest -->
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <div class="col max-w-[550px]">
    <img src="/assets/v4/channel-first-account.svg" width="100%" alt="" />
  </div>
</div>
